import { SERVER_MNG } from '@/api/apiModules'
export default {
  refreshInterval: false,
  viewType: 'table',
  module: SERVER_MNG,
  relationSearch: true,
  allowStatus: {},
  toolbar: {
    searchPlaceholder: '请输入服务器型号',
    moreBtnWidth: 160,
    searchFieldNameArr: ['serverName'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'serverCreate'
      }
    ]
  },
  view: {
    columns: [
      {
        props: {
          label: '服务器型号',
          prop: 'serverName',
          sortField: 'serverName'
        }
      },
      {
        props: {
          label: '描述',
          prop: 'serverDesc'
        }
      },
      {
        props: {
          label: 'CPU描述',
          prop: 'cpu',
          sortField: 'cpu'
        }
      },
      {
        props: {
          label: '内存',
          prop: 'memory',
          sortField: 'memory'
        }
      },
      {
        props: {
          label: '磁盘',
          prop: 'diskInfo',
          sortField: 'diskInfo'
        }
      },
      {
        props: {
          label: '网卡',
          prop: 'nicsInfo',
          sortField: 'nicsInfo'
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime'
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          sortField: 'updateTime'
        },
        dataType: 'date'
      },
      {
        //操作
        props: {
          showBtnNum: '2'
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: 'edit',
        command: 'serverEdit',
        name: 'edit'
      }
      // {
      //   icon: 'el-icon-delete',
      //   label: 'delete',
      //   command: 'serverDelete',
      //   name: 'delete',
      //   confirm: {
      //     msg: 'tips.confirm.serverMng.deleteMsg'
      //   }
      // }
    ]
  }
}
